/* unplugin-vue-components disabled */import { render } from "./SysCogSecurity.vue?vue&type=template&id=264510a6&scoped=true"
import script from "./SysCogSecurity.vue?vue&type=script&lang=js"
export * from "./SysCogSecurity.vue?vue&type=script&lang=js"

import "./SysCogSecurity.vue?vue&type=style&index=0&id=264510a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264510a6"]])

export default __exports__